/**
 * Shared constants for the Etch knowledge explorer (spec §9.5, §10.5).
 *
 * Storage keys follow the `etch.` prefix contract (spec §14); the pre-Etch
 * `ide-panel-state` key is deliberately abandoned, not migrated.
 */

export const STORAGE_KEYS = {
  layout: 'etch.knowledge.layout',
  graphMode: 'etch.knowledge.graphMode'
};

/** Left rail sources. */
export const SOURCES = {
  files: 'files',
  documents: 'documents',
  symbols: 'symbols'
};

/** Main-panel surfaces. */
export const SURFACES = {
  preview: 'preview',
  architecture: 'architecture',
  callgraph: 'callgraph',
  impact: 'impact'
};

/** Graph surfaces render either the visual graph or its tabular alternative. */
export const GRAPH_MODES = {
  graph: 'graph',
  table: 'table'
};

/** `changeType` values accepted by `POST /api/ckb/prepare-change`. */
export const CHANGE_TYPES = ['modify', 'rename', 'delete', 'extract'];

/**
 * Navigation-intent paths this view consumes. Every in-app producer now emits
 * `/knowledge`; `/ide` stays accepted so a bookmark or an external link that
 * still carries the pre-Etch path lands here instead of losing its payload.
 */
export const INTENT_PATHS = ['/knowledge', '/ide'];
